import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import * as actions from './../../redux/actions'
import autobind from 'react-autobind'
import { withRouter } from 'react-router-dom';

import Dropzone from 'react-dropzone';
import { Container, Row, Col } from 'reactstrap';
import Alert from './../../components/Errors/Alert'
import Dialog from './../../components/Dialog/Dialog';
import AlertSuccess from './../../components/Success/Alert'
import { Modal, ModalBody, ModalHeader } from 'reactstrap';


import Header from './../../components/Header';
import Subheader from './../../components/Subheader';
import Footer from './../../components/Footer';


// field groups
const ACCOUNT_SETTINGS_FIELD_GROUP = 'ACCOUNT_SETTINGS_FIELD_GROUP';
const PAYMENT_DETAILS_FIELD_GROUP = 'PAYMENT_DETAILS_FIELD_GROUP';
const CONTACT_PERSON_FIELD_GROUP = 'CONTACT_PERSON_FIELD_GROUP';

class MyProfilePage extends PureComponent {

    constructor(props) {
        super(props);
        autobind(this);

        this.state = {
            accountSettingsEditable: false,
            paymentDetailsEditable: false,
            contactPersonEditable: false,

            // account settings
            profileUserName: '',
            profileEmail: '',
            profilePhone: '',

            // payment details
            companyName: '',
            CUI: '',
            accountNumber: '',

            // contact person
            contactName: '',
            contactPhone: '',
            contactEmail: '',

            resetPasswordModalOpen: false,
            confirmDeleteModalOpen: false,

            currentPassword: '',
            newPassword: '',
            confirmNewPassword: '',
            resetPasswordSuccess: false
        }

    }

    componentDidMount() {
        const { user } = this.props
        this.profilePropsToState(user)
        this.props.getMySubscriptions()
    }

    componentWillReceiveProps(props) {

        const { user } = props
        if (user) this.profilePropsToState(user)

    }

    profilePropsToState(user) {
        this.setState({
            profilePicture: user.picturePath,
            profileUserName: user.username,
            profileEmail: user.email,
            profilePhone: user.phone,
            companyName: user.paymentDetails ? user.paymentDetails.companyName : "",
            CUI: user.paymentDetails ? user.paymentDetails.CUI : "",
            accountNumber: user.paymentDetails ? user.paymentDetails.accountNumber : "",
            contactName: user.contactPersons ? user.contactPersons.name : "",
            contactPhone: user.contactPersons ? user.contactPersons.phoneNumber : "",
            contactEmail: user.contactPersons ? user.contactPersons.email : "",
        })
    }

    updateProfileUserName(e) {
        this.setState({
            profileUserName: e.target.value
        })
    }

    updateProfileEmail(e) {
        this.setState({
            profileEmail: e.target.value
        })
    }

    updateProfilePhone(e) {
        this.setState({
            profilePhone: e.target.value
        })
    }

    updateAccountSettings() {
        const { profileUserName, profileEmail, profilePhone } = this.state
        this.props.updateProfile({
            username: profileUserName,
            email: profileEmail,
            phone: profilePhone
        }, () => {
            this.setState({
                accountSettingsEditable: false
            })
        }, ACCOUNT_SETTINGS_FIELD_GROUP)
    }

    updateProfilePicture(acceptedFiles) {
        this.props.updateUserProfilePicture(acceptedFiles[0])
    }

    getAccountSettingsView(error) {

        console.log(error)

        if (this.state.accountSettingsEditable) {
            return {
                actionButtons:
                    (<div className="d-flex align-items-center">
                        <span className="ar-icon s7-check" onClick={this.updateAccountSettings}>
                        </span><span className="ar-icon s7-close" onClick={() => { this.setState({ accountSettingsEditable: false }, () => this.profilePropsToState(this.props.user)) }}></span>
                    </div>),
                properties:
                    (
                        <div>
                            {error.messages && error.fieldGroup === ACCOUNT_SETTINGS_FIELD_GROUP ? <Alert message={error.messages} /> : null}
                            <div className="form-group mb-1 row">
                                <div className="col-3 pt-1">
                                    <img src={this.state.profilePicture} className="my-profile-user-avatar" alt="" />
                                </div>
                                <div className="col-9 pt-1">
                                    <Dropzone
                                        onDrop={(accepted, rejected) => { this.updateProfilePicture(accepted, rejected) }}
                                        className="col-form-label text-highlighted hover">
                                        Change Photo
                                    </Dropzone>
                                </div>
                            </div>
                            <div className="form-group mb-1 row">
                                <label htmlFor="name" className="col-3 col-form-label">Author Name</label>
                                <div className="col-9 pt-1">
                                    <input type="text" id="name" placeholder="Enter name" className="form-control form-control-xs" value={this.state.profileUserName} onChange={this.updateProfileUserName} />
                                </div>
                            </div>
                            <div className="form-group mb-1 row">
                                <label htmlFor="email" className="col-3 col-form-label">Email</label>
                                <div className="col-9 pt-1">
                                    <input type="email" id="email" placeholder="Enter email" className="form-control form-control-xs" value={this.state.profileEmail} onChange={this.updateProfileEmail} />
                                </div>
                            </div>

                            <div className="form-group mb-1 row">
                                <label htmlFor="phone" className="col-3 col-form-label">Phone</label>
                                <div className="col-9 pt-1">
                                    <input type="text" id="phone" placeholder="Enter phone" className="form-control form-control-xs" value={this.state.profilePhone} onChange={this.updateProfilePhone} />
                                </div>
                            </div>
                        </div>
                    )
            }
        } else {
            return {
                actionButtons:
                    (<div>
                        <span className="ar-icon s7-edit" onClick={() => { this.setState({ accountSettingsEditable: true }) }}></span>
                    </div>),
                properties:
                    (
                        <div>
                            <div className="form-group mb-1 row">
                                <div className="col-3 pt-1">
                                    <img src={this.state.profilePicture} className="my-profile-user-avatar" alt="" />
                                </div>
                                <div className="col-9 pt-1">
                                    <Dropzone
                                        onDrop={(accepted, rejected) => { this.updateProfilePicture(accepted, rejected) }}
                                        className="col-form-label text-highlighted hover">
                                        Change Photo
                                    </Dropzone>
                                </div>
                            </div>
                            <div className="form-group mb-1 row">
                                <label htmlFor="name" className="col-3 col-form-label">Author Name</label>
                                <div className="col-9">
                                    <p className="col-form-label text-highlighted">{this.state.profileUserName}</p>
                                </div>
                            </div>
                            <div className="form-group mb-1 row">
                                <label htmlFor="email" className="col-3 col-form-label">Email</label>
                                <div className="col-9">
                                    <p className="col-form-label text-highlighted">{this.state.profileEmail}</p>
                                </div>
                            </div>
                            <div className="form-group mb-1 row">
                                <label htmlFor="phone" className="col-3 col-form-label">Phone</label>
                                <div className="col-9">
                                    <p className="col-form-label text-highlighted">{this.state.profilePhone}</p>
                                </div>
                            </div>
                        </div>
                    )
            }
        }

    }

    updateCompanyName(e) {
        this.setState({
            companyName: e.target.value
        })
    }

    updateCUI(e) {
        this.setState({
            CUI: e.target.value
        })
    }

    updateAccountNumber(e) {
        this.setState({
            accountNumber: e.target.value
        })
    }

    updatePaymentDetails() {
        const { companyName, CUI, accountNumber, profileUserName, profileEmail, profilePhone } = this.state
        this.props.updateProfile({
            username: profileUserName,
            email: profileEmail,
            phone: profilePhone,
            paymentDetails: {
                companyName,
                CUI,
                accountNumber
            }
        }, () => {
            this.setState({
                paymentDetailsEditable: false
            })
        }, PAYMENT_DETAILS_FIELD_GROUP)
    }

    getPaymentDetailsView(error) {
        if (this.state.paymentDetailsEditable) {
            return {
                actionButtons:
                    (<div className="d-flex align-items-center">
                        <span className="ar-icon s7-check" onClick={this.updatePaymentDetails}>
                        </span><span className="ar-icon s7-close" onClick={() => { this.setState({ paymentDetailsEditable: false }, () => this.profilePropsToState(this.props.user)) }}></span>
                    </div>),
                properties:
                    (
                        <div>
                            {error.messages && error.fieldGroup === PAYMENT_DETAILS_FIELD_GROUP ? <Alert message={error.messages} /> : null}
                            <div className="form-group mb-1 row">
                                <label htmlFor="companyName" className="col-5 col-form-label">Name</label>
                                <div className="col-6 pt-1">
                                    <input type="text" id="companyName" placeholder="Enter author name" className="form-control form-control-xs" value={this.state.companyName} onChange={this.updateCompanyName} />
                                </div>
                            </div>

                            <div className="form-group mb-1 row">
                                <label htmlFor="cui" className="col-5 col-form-label">Reg. Number/SSN</label>
                                <div className="col-6 pt-1">
                                    <input type="text" id="cui" placeholder="Enter Reg. No./SSN" className="form-control form-control-xs" value={this.state.CUI} onChange={this.updateCUI} />
                                </div>
                            </div>

                            <div className="form-group mb-1 row">
                                <label htmlFor="accountNumber" className="col-5 col-form-label">Account number</label>
                                <div className="col-6 pt-1">
                                    <input type="text" id="accountNumber" placeholder="Enter account number" className="form-control form-control-xs" value={this.state.accountNumber} onChange={this.updateAccountNumber} />
                                </div>
                            </div>
                        </div>
                    )
            }
        } else {
            return {
                actionButtons:
                    (<div>
                        <span className="ar-icon s7-edit" onClick={() => { this.setState({ paymentDetailsEditable: true }) }}></span>
                    </div>),
                properties:
                    (
                        <div>
                            <div className="form-group mb-1 row">
                                <label htmlFor="companyName" className="col-5 col-form-label">Name</label>
                                <div className="col-6">
                                    <p className="col-form-label text-highlighted">{this.state.companyName}</p>
                                </div>
                            </div>
                            <div className="form-group mb-1 row">
                                <label htmlFor="cui" className="col-5 col-form-label">Reg. Number/SSN</label>
                                <div className="col-6">
                                    <p className="col-form-label text-highlighted">{this.state.CUI}</p>
                                </div>
                            </div>
                            <div className="form-group mb-1 row">
                                <label htmlFor="accountNumber" className="col-5 col-form-label">Account number</label>
                                <div className="col-6">
                                    <p className="col-form-label text-highlighted">{this.state.accountNumber}</p>
                                </div>
                            </div>
                        </div>
                    )
            }
        }
    }

    updateContactName(e) {
        this.setState({
            contactName: e.target.value
        })
    }

    updateContactPhone(e) {
        this.setState({
            contactPhone: e.target.value
        })
    }

    updateContactEmail(e) {
        this.setState({
            contactEmail: e.target.value
        })
    }

    updateContactPerson() {
        const { contactName, contactPhone, contactEmail, profileUserName, profileEmail, profilePhone } = this.state
        this.props.updateProfile({
            username: profileUserName,
            email: profileEmail,
            phone: profilePhone,
            contactPersons: {
                name: contactName,
                phoneNumber: contactPhone,
                email: contactEmail
            }
        }, () => {
            this.setState({
                contactPersonEditable: false
            })
        }, CONTACT_PERSON_FIELD_GROUP)
    }

    getContactPersonView(error) {

        if (this.state.contactPersonEditable) {
            return {
                actionButtons:
                    (<div className="d-flex align-items-center">
                        <span className="ar-icon s7-check" onClick={this.updateContactPerson}>
                        </span><span className="ar-icon s7-close" onClick={() => { this.setState({ contactPersonEditable: false }, () => this.profilePropsToState(this.props.user)) }}></span>
                    </div>),
                properties:
                    (
                        <div>
                            {error.messages && error.fieldGroup === CONTACT_PERSON_FIELD_GROUP ? <Alert message={error.messages} /> : null}
                            <div className="form-group mb-1 row">
                                <label htmlFor="contactName" className="col-3 col-form-label">Name</label>
                                <div className="col-9 pt-1">
                                    <input type="text" id="contactName" placeholder="Enter name" className="form-control form-control-xs" value={this.state.contactName} onChange={this.updateContactName} />
                                </div>
                            </div>

                            <div className="form-group mb-1 row">
                                <label htmlFor="contactPhone" className="col-3 col-form-label">Phone</label>
                                <div className="col-9 pt-1">
                                    <input type="text" id="contactPhone" placeholder="Enter phone" className="form-control form-control-xs" value={this.state.contactPhone} onChange={this.updateContactPhone} />
                                </div>
                            </div>

                            <div className="form-group mb-1 row">
                                <label htmlFor="contactEmail" className="col-3 col-form-label">Email</label>
                                <div className="col-9 pt-1">
                                    <input type="text" id="contactEmail" placeholder="Enter email" className="form-control form-control-xs" value={this.state.contactEmail} onChange={this.updateContactEmail} />
                                </div>
                            </div>
                        </div>
                    )
            }
        } else {
            return {
                actionButtons:
                    (<div>
                        <span className="ar-icon s7-edit" onClick={() => { this.setState({ contactPersonEditable: true }) }}></span>
                    </div>),
                properties:
                    (
                        <div>
                            <div className="form-group mb-1 row">
                                <label htmlFor="contactName" className="col-3 col-form-label">Name</label>
                                <div className="col-9">
                                    <p className="col-form-label text-highlighted">{this.state.contactName}</p>
                                </div>
                            </div>
                            <div className="form-group mb-1 row">
                                <label htmlFor="contactPhone" className="col-3 col-form-label">Phone</label>
                                <div className="col-9">
                                    <p className="col-form-label text-highlighted">{this.state.contactPhone}</p>
                                </div>
                            </div>
                            <div className="form-group mb-1 row">
                                <label htmlFor="contactEmail" className="col-3 col-form-label">Email</label>
                                <div className="col-9">
                                    <p className="col-form-label text-highlighted">{this.state.contactEmail}</p>
                                </div>
                            </div>
                        </div>
                    )
            }
        }
    }

    toggleResetPasswordModal() {
        this.setState({
            resetPasswordModalOpen: !this.state.resetPasswordModalOpen
        })
    }

    confirmDeleteModalProceed() {
        this.props.deleteMyProfile(() => {
            this.confirmDeleteModalHide()
        })
    }

    confirmDeleteModalShow(notificationId) {
        this.setState({
            confirmDeleteModalOpen: true
        })
    }

    confirmDeleteModalHide() {
        this.setState({
            confirmDeleteModalOpen: false
        })
    }

    updateCurrentPassword(e) {
        this.setState({
            currentPassword: e.target.value
        })
    }

    updateNewPassword(e) {
        this.setState({
            newPassword: e.target.value
        })
    }

    updateConfirmNewPassword(e) {
        this.setState({
            confirmNewPassword: e.target.value
        })
    }

    resetPassword() {
        this.props.resetPassword({
            oldPassword: this.state.currentPassword,
            newPassword: this.state.newPassword,
            newPasswordConfirmation: this.state.confirmNewPassword
        }, () => {
            this.setState({
                resetPasswordSuccess: true
            })
        })
    }

    render() {

        const { resetPasswordError, updateError } = this.props;

        const accountSettingsView = this.getAccountSettingsView(updateError);
        const paymentDetailsView = this.getPaymentDetailsView(updateError);
        const contactPersonView = this.getContactPersonView(updateError);
        if (this.state.resetPasswordSuccess) {
            setTimeout(() => this.setState({
                resetPasswordModalOpen: false,
                resetPasswordSuccess: false,
                currentPassword: '',
                newPassword: '',
                confirmNewPassword: ''
            }), 500)
        }
        return (
            <div>
                <Header />
                <Subheader breadcrumbs={["My Account"]} />
                <Container className="mt-5">
                    {/*
                    <Row style={{ paddingLeft: 10, paddingRight: 10 }}>
                        {subscriptions ? _.map(subscriptions.subscriptionsActive, (subscription) => {

                            const styleMapper = {
                                BEST_CHOICE: 'pricing-table-orange',
                                DEMO: 'pricing-table-free',
                                BASIC: 'pricing-table-basic'
                            }

                            return (<Col xs="3" style={{ paddingLeft: 5, paddingRight: 5 }} key={subscription._id}><div className={"pricing-table pricing-table-small " + styleMapper[subscription.subscription.style]}>
                                <div className="domain">{subscription.subscription.domain.name} Plan</div>
                                <div className="d-flex justify-content-between align-items-center">
                                    <div className="pricing-table-title mb-0">{subscription.subscription.name}</div>
                                    <div className="pricing-table-price mb-0"><span className="value">{subscription.subscription.price ? subscription.subscription.price + '€' : 'FREE'}</span></div>
                                </div>
                                <ul className="pricing-table-features mt-4">
                                    <li><b>{subscription.subscription.storageText}</b></li>
                                    <li><b>{subscription.subscription.trafficText}</b></li>
                                </ul>
                                <Link className="btn btn-rounded btn-sm-lateral-space btn-space btn-secondary" to={'/payment-plans/' + subscription.subscription.domain._id + '/upgrade'}>Upgrade</Link>
                            </div></Col>)
                        }) : null}
                        {subscriptions ? _.map(subscriptions.domainsInactive, (domain) => {

                            return (<Col xs="3" style={{ paddingLeft: 5, paddingRight: 5 }} key={domain._id}><div className="pricing-table pricing-table-small pricing-table-dark">
                                <div className="domain mb-3">{domain.name} Plan</div>
                                <div className="d-flex justify-content-between align-items-center">
                                    <div className="pricing-table-title mb-0">Inactive</div>
                                </div>
                                <div className="d-flex align-items-end justify-content-center" style={{ height: 180 }}>
                                    <Link className="btn btn-rounded btn-sm-lateral-space btn-space btn-primary" to={'/payment-plans/' + domain._id + '/new'}>See all plans</Link>
                                </div>
                            </div></Col>)
                        }) : null}
                    </Row>
                    */}
                    <Row>
                        <Col xs="4">
                            <div className="panel panel-default">
                                <div className="panel-body panel-body--md">
                                    <h5 className="mb-5">Account Settings</h5>
                                    <div className="panel-icon-right">
                                        {accountSettingsView.actionButtons}
                                    </div>
                                    {accountSettingsView.properties}
                                    <button className="btn btn-space btn-sm-lateral-space btn-secondary btn-rounded btn-lg mt-4" onClick={this.toggleResetPasswordModal}>Change Password</button>
                                </div>
                            </div>
                        </Col>
                        <Col xs="4">
                            <div className="panel panel-default">
                                <div className="panel-body panel-body--md">
                                    <h5 className="mb-5">Payment Details</h5>
                                    <div className="panel-icon-right">
                                        {paymentDetailsView.actionButtons}
                                    </div>
                                    {paymentDetailsView.properties}
                                </div>
                            </div>
                        </Col>
                        <Col xs="4">
                            <div className="panel panel-default">
                                <div className="panel-body panel-body--md">
                                    <h5 className="mb-5">Contact Person</h5>
                                    <div className="panel-icon-right">
                                        {contactPersonView.actionButtons}
                                    </div>
                                    {contactPersonView.properties}
                                </div>
                            </div>
                        </Col>
                        <Col xs="4">
                            <div className="panel panel-default">
                                <div className="panel-body">
                                    <p className="text-center">indexAR Platform <a href='https://indexar.tech/terms-and-conditions/#companies' rel="noopener noreferrer" target="_blank">Terms and Conditions</a> and <a href='https://indexar.tech/terms-and-conditions/#privacy-policy' rel="noopener noreferrer" target="_blank">Privacy Policy</a></p>
                                </div>
                            </div>
                            <div className="d-flex justify-content-center">
                                <button className="btn btn-space btn-transparent btn-sm-lateral-space btn-secondary btn-rounded btn-lg mt-2" onClick={this.confirmDeleteModalShow}>Delete account</button>
                            </div>
                        </Col>
                    </Row>
                </Container>
                <Modal isOpen={this.state.resetPasswordModalOpen} toggle={this.toggleResetPasswordModal} className="modal-md">
                    <ModalHeader>
                        <span onClick={this.toggleResetPasswordModal} className="s7-close modal-close"></span>
                    </ModalHeader>
                    <ModalBody className="pt-0">
                        <div className="row d-flex justify-content-center">
                            <div className="col-8">
                                {this.state.resetPasswordSuccess ? (<AlertSuccess message="Your password has been reset." path={null} />) : null}
                                {resetPasswordError ? <Alert message={resetPasswordError} /> : null}
                                <label className="mb-3">Current password:</label>
                                <input type="password" placeholder="Current password" className="form-control form-control-xs mb-4" value={this.state.currentPassword} onChange={this.updateCurrentPassword} />
                                <label className="mb-3">New password:</label>
                                <input type="password" placeholder="New password" className="form-control form-control-xs mb-4" value={this.state.newPassword} onChange={this.updateNewPassword} />
                                <input type="password" placeholder="Confirm new password" className="form-control form-control-xs mb-4" value={this.state.confirmNewPassword} onChange={this.updateConfirmNewPassword} />
                                <button className="btn btn-space btn-primary" onClick={this.resetPassword}>Confirm change password</button>
                            </div>
                        </div>
                    </ModalBody>
                </Modal>
                <Dialog open={this.state.confirmDeleteModalOpen} proceed={this.confirmDeleteModalProceed} cancel={this.confirmDeleteModalHide} message="You'll lose access to your account." />
                <Footer />
            </div>
        );
    }
}

export default connect(
    (state, ownProps) => {
        const { auth: { user, updateError, resetPasswordError, subscriptions } } = state

        return { user, updateError, subscriptions, resetPasswordError }
    },
    actions,
    (stateProps, dispatchProps) => {
        return Object.assign({}, stateProps, dispatchProps)
    }
)(withRouter(MyProfilePage))



// WEBPACK FOOTER //
// ./src/containers/Profile/MyProfile.js